import { render } from "./EditProduct.vue?vue&type=template&id=ff8c96a0&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=ff8c96a0&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8c96a0"]])

export default __exports__